import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import { LifeBuoy, Send, ShieldBan } from "lucide-react";

import { auth } from "../../firebase";
import { onAuthStateChanged } from "firebase/auth";

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarSeparator,
} from "../../components/ui/sidebar";

const SecondarySidebar = () => {
  const [isAuthorized, setIsAuthorized] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const checkUserRole = async (firebaseUser) => {
      try {
        // Get the ID token and decode the custom claims
        const idTokenResult = await firebaseUser.getIdTokenResult();

        // Check if the user has the 'admin' role
        if (idTokenResult.claims.role === "admin") {
          setIsAuthorized(true);
        } else {
          setIsAuthorized(false);
        }
      } catch (error) {
        console.error("Error checking role:", error);
        setIsAuthorized(false);
      }
    };

    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        // Force token refresh to retrieve the new custom claims if any
        await firebaseUser.getIdToken(true);

        checkUserRole(firebaseUser);
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <SidebarGroup className="mt-auto">
      <SidebarGroupContent>
        <SidebarMenu>
          {isAuthorized && location.pathname !== "/admin-portal" && (
            <div>
              <SidebarMenuItem>
                <SidebarMenuButton asChild>
                  <Link to="/admin-portal">
                    <ShieldBan />
                    <span>Admin Portal</span>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>

              <SidebarSeparator className="my-2" />
            </div>
          )}

          <SidebarMenuItem>
            <SidebarMenuButton asChild>
              <a href="https://aihazardlog.atlassian.net/servicedesk/customer/portal/1" target="_blank" rel="noopener noreferrer">
                <LifeBuoy />
                <span>Support</span>
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>

          <SidebarMenuItem>
            <SidebarMenuButton asChild>
              <a href="https://aihazardlog.atlassian.net/servicedesk/customer/portal/1" target="_blank" rel="noopener noreferrer">
                <Send />
                <span>Feedback</span>
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
};

export default SecondarySidebar;
